import React from "react";
import { getDate } from "@herb/utils/date";
import getCategoryPath from "@herb/utils/categoryPath";
import { deployUrl } from "@herb/utils";
import ReactHtmlParser from "react-html-parser";
import "./index.css";
import { Link } from "gatsby";

const ArticleBreadCrumb = ({
  date,
  category,
  categories,
  path,
  legacy,
  post,
  showDate = true,
  showTitle = true,
  seprator = "default",
  ...props
}) => {
  const seperator =
    seprator == "default" ? (
      <>&gt;</>
    ) : (
      <>
        <span className="desktop-only custom-seperator">
          <svg
            width="7"
            height="8"
            viewBox="0 0 7 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.84876 6.63143L5.85059 4.00001L1.84876 1.36859"
              stroke="black"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </span>
        <span className="mobile-only custom-seperator">
          <svg
            width="4"
            height="5"
            viewBox="0 0 4 5"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.00004 3.65713L3.02051 2.32857L1.00004 1"
              stroke="black"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </span>
      </>
    );
  if (!legacy) {
    category =
      (category && (category[0] || {}).name) ||
      (category || {}).name ||
      category ||
      "Category";
  }
  const convertAlgoliaDate = d => {
    d = d.split("T");

    d = d[0].split("-");
    d = d[1] + "." + d[2] + "." + d[0];

    return d;
  };

  if ((date || "").includes("T")) {
    date = (date && convertAlgoliaDate(date)) || "01.01.2022";
  } else {
    date = (date && getDate(date)) || "01.01.2022";
  }

  return (
    <div className="articleBreadCrumb">
      <Link className="cusColor" to="/">
        Home
      </Link>
      {seperator}
      <Link
        className="cusColor"
        to={path ? path : `/${getCategoryPath(categories)}`}
      >
        {category}
      </Link>
      {showTitle ? (
        <>
          {seperator}
          <p className="articleTitle">
            {legacy ? ReactHtmlParser(post?.title) : post?.title}{" "}
            <span className="cusColor"> | </span>
          </p>
          {showDate ? date : ""}
        </>
      ) : (
        ""
      )}
    </div>
  );
};

export default ArticleBreadCrumb;
